<template>
    <div class="page-main">
        <div class="vertify-title">安全中心</div>
        <div class="text-color-grey" v-if="!centerInfo">加载失败请稍后重试</div>
        <div class="vertify-li spaceLeft" v-for="item in centerInfo" :key="item.name">
            <div class="vertify-li-title">{{item.header}}</div>
            <div class="width-auto">
                <span v-if="item.name!=='aprvSt' || securityInfo.aprvSt!=='2'">{{item.content}}</span>
                <a-popover v-else>
                    <template slot="content">
                        <h5>审核意见</h5>
                        <p>{{aproPopContent}}</p>
                    </template>
                    <span>{{item.content}}</span>
                </a-popover>
            </div>
            <div>
                <span v-if="item.remark">{{ item.remark }}</span>
                <a v-if="item.modifyText"  @click="item.modifyFlag=!item.modifyFlag">{{ item.modifyText }}</a>
                <template v-if="item.routersFlag">
                    <a v-for="oper in item.routers" :key="oper.text" @click="toPage(oper.uri)">{{oper.text}}</a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {getUserInfo,getApproveInfoByAprvId} from "@/api/security.js"
export default {
    name:"vertify-management",
    data() {
        return {
            isAdmin: JSON.parse(localStorage.getItem('CURRENTROLE')).includes('ROLE0000'),
            securityInfo:{},
            centerInfo:null
        };
    },
    computed: {},
    methods: {
        getUserInfo(){
            getUserInfo(null,true)
            .then(res => {
                const info = this.securityInfo = res.data;
                if (res.data.aprvSt === '2') {
                    this.getApproveInfoByAprvId(res.data.aprvId);
                }
                this.centerInfo = [
                    {
                        name: 'cstNm',
                        header: '用户信息',
                        content: this.utils.xxShow('name',info.loginName) + ' ( 姓名:' + info.mnpltPsnNm + ' 身份证号:' + info.certificateNum + ' )',
                    },
                    {
                        name: 'password',
                        header: '登录密码',
                        content: '已设置',
                        routersFlag: true,
                        routers: [{
                            text: '修改',
                            uri: 'security/pswd-modify'
                        }],
                    },
                    {
                        name: 'txnPswd',
                        header: '交易密码',
                        content: info.txnPswdFlag ? '已设置' : '未设置',
                        routersFlag: true,
                        routers: [{
                            text: info.txnPswdFlag ? '修改' : '设置',
                            uri: 'security/txnpswd-modify',
                        }]
                    },
                    {
                        name: 'mobile',
                        header: '密保手机',
                        content: this.utils.xxShow('tel',info.mobile),
                        remark: info.isChange ? '操作人信息审核中' : '',
                        routersFlag: !info.isChange && this.isAdmin,
                        routers: [{
                            text: '修改',
                            uri: 'security/mobile-modify'
                        }],
                    },
                    {
                        name: 'email',
                        header: '密保邮箱',
                        state: info.emailFlag,
                        content: info.emailFlag ? this.utils.xxShow('email',info.email) : '未设置',
                        modifyFlag: false, modifyText: info.emailFlag ? '' : '绑定',
                        modifyTemp: 'email',
                        routersFlag: info.emailFlag && this.isAdmin,
                        routers: [{
                        text: '修改',
                        uri: 'security/email-modify'
                        }],
                    }
                ];
            })
            .catch(err => {
                console.log(err);
            })
        },
        getApproveInfoByAprvId(aprvId){
            getApproveInfoByAprvId({aprvId: aprvId})
            .then(resData => {
                this.aproPopContent = resData.data.apvOpn || "";
            })
            .catch(err => {
                console.log(err);
            });
        },
        toPage(path){
          this.$router.push("/" + path)
        }
    },
    created() {
        this.getUserInfo();
    },
    mounted() {

    },
    watch: {}
};
</script>
<style scoped>
    .vertify-title{
        font-size: 14px;
        color: #667380;
        line-height: 20px;
        font-family: Lucida Grande, Lucida Sans Unicode, Hiragino Sans GB, WenQuanYi Micro Hei, Verdana, Aril, sans-sefi, 微软雅黑;
        letter-spacing: 0;
        margin:15px 0;
    }
    .vertify-li-title{
        color:#0d253e;
        font-weight: bold;
        max-width: 300px;
        width: 30%;
    }
    .vertify-li{
        min-height: 75px;
        padding-left: 15px;
    }
    .vertify-li a{
        margin:0 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/security/main/main.vue